import { Skeleton } from '@/components/UI/Skeleton'

export function RewardOverviewSkeleton() {
  // RewardOverview と同じ余白・最小高さにして、ローディング解除時に行の高さが動かないようにする
  return (
    <div className="flex min-h-[132px] items-start gap-4 px-4 py-4">
      {/* サムネイル */}
      <Skeleton variant="rect" width={100} height={100} className="shrink-0 rounded-[16px]" />

      {/* テキスト情報（縦間隔は gap:4px で一元管理） */}
      <div className="flex min-w-0 flex-1 flex-col gap-1">
        {/* 特典名 1 行分（16px / line-height 24px） */}
        <Skeleton variant="text" width="70%" height={24} />
        {/* 獲得状況バッジ 1 個分（高さ 20px） */}
        <Skeleton variant="rect" width={56} height={20} />
        {/* 条件テキスト 1 行分（12px / line-height 16px） */}
        <Skeleton variant="text" width="50%" height={16} />
      </div>

      {/* 矢印 */}
      <Skeleton variant="circle" width={24} className="shrink-0 self-center" />
    </div>
  )
}
